import { PlayCircleRounded, ShoppingCartCheckoutRounded, ShoppingCartRounded } from "@mui/icons-material";
import {
    alpha,
    LinearProgress,
    Button,
    Skeleton,
    Stack,
    Typography,
    styled,
    Tooltip,
    Fab,
    Box,
    useTheme,
    useMediaQuery,
    Rating
} from "@mui/material";
import { useRouter } from "next/router";
import { useSnackbar } from "notistack";
import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { reduxHelper } from "../../config/reduxHelper";
import { useAddToCart } from "../../hooks/useAddToCart";
import { useCheckCart } from "../../hooks/useCheckCart";
import { useProgramPricing } from "../../hooks/useProgramPricing";
import EkhoolImage from "../ekhoolImage/ekhoolImage";
import Label from "../extras/Label";
import { getString } from "../../functions/getString";
import Iconify from "../Iconify";
import { icons } from "../../config/icons";
import StackImage from "./stackImage";
import useDevice from "../../hooks/useDevice";
import Cookies from "js-cookie";
import { TOKEN_KEY, CALL_BACK_URL_KEY } from "../../config/key";
import { HTTP_REST_URLS } from "../../config/urls";


const LineStyle = styled(Stack)(({ theme }) => ({
    height: 3,
    width: "100%",
    backgroundColor: "#808080",
    borderRadius: 10,
}));

function BundlesCard({ item, view }) {

    const title                             = item.bb_title;
    const code                              = item.bb_code? item.bb_code :"";
    const enrolled                          = item.enrolled;
    const selfEnrolled                      = item.bb_has_self_enroll;
    const selfEnrolledDate                  = item.bb_self_enroll_date;
    const isFutureDate                      = item?.futureDate
    const thumbnail                         = item.bb_image;
    const percentage                        = item.percentage;
    const totalLearners                     = item?.enrolled_learners;
    const shortDescription                  = item?.bb_short_description;
    const description                       = item?.bb_description;
    const totalRating                       = item?.ratting === "" ? 0 : item?.ratting;
    const createdDate                       = item?.created_date;
    const totalLessons                      = item?.lessons?.length;
    const unlimitedBundle                   = item.unlimited_validity;
    const subscriptionEndData               = item?.subscription_end_date;
    const userSuspended                     = item?.learner_suspended;
    const bundleSubscriptionExpired         = item?.expired;
    const addonsCount                       = item?.bb_products != undefined ? item?.bb_products : null;
    const bundleExpired                     = item?.validity_expired;
    const programsLength                    = item?.programs_count;
    const currentDate                       = new Date().toISOString().split("T")[0];

    const [priceData, setPriceData]         = useState(null);
    const [itemOnCart, setItemOnCart]       = useState(false);
    const [isMonthlyPay, setIsMonthlyPay]   = useState();

    const bundleDuration                    = item?.bb_preview_time;
    const totalEnrolledLearners             = item?.bb_total_enrolled_learners || item?.enrolled_learners;
    const certifiedBundle                   = item?.bb_has_certificate;

    const { reducer }                       = useSelector((state) => state);
    const { appData, cartItems, user }      = reducer;
    const priceSymbol                       = appData?.amount_details?.symbol;

    const monthPayment                      = item && item.bb_month_payment ? item.bb_month_payment : null;
    const parsedMonthPayment                = monthPayment && JSON.parse(monthPayment);
    const filteredData                      = parsedMonthPayment && parsedMonthPayment.filter((i) => i.show == "1");
    const priceToShow                       = filteredData && filteredData.length > 0 && filteredData[0].price;

    const strickoutDetail                   = item?.bb_discount_value;
    const CoursePrice                       = item?.bb_price;
    const percentageValue                   = parseInt(strickoutDetail) - parseInt(CoursePrice);
    const percentageAmount                  =(parseInt(percentageValue) / parseInt(strickoutDetail)) * 100;
    const percentageRound                   = Math.round(percentageAmount);

    const enrolledPath                      = `/bundle/${item?.bb_slug}`;
    const notEnrolledPath                   = `/bundle/${item?.bb_slug}`;
    const pathWithLastPlayed                = `/bundle/${item?.bb_slug}/learn/${item?.ps_last_played_material}`;
    const hasLastPlayed                     =  item?.ps_last_played_material !== undefined &&item?.ps_last_played_material != 0;

    const showPricing                       = appData?.enable_learner_purchase;
    const enableBundlePurchase              = appData?.enable_bundle_self_enrollment;

    // const hasAddons                      = Array.isArray(addonsCount) && addonsCount.length > 0;

    const hasAddons                         = Array.isArray(item?.addon) && item?.addon.length > 0;

    let navigatePath                        = enrolled ? enrolledPath : notEnrolledPath;

    const { isDesktop, isTablet, isMobile } = useDevice();
    const [enrolling, setEnrolling]         = useState(false);

    const getPriceData = async () => {
        let bundleObject    = { bundle_detail: item };
        const result        = useProgramPricing(bundleObject);
        setPriceData(result);
    };

    const dispatch = useDispatch();

    const getBundlePricingForMonth = () => {
        if (parsedMonthPayment != null) {
            parsedMonthPayment.forEach((i) => {
                if (i.show == true) setIsMonthlyPay(i);
            });
        }
    };

    const monthlypayments       = isMonthlyPay?.price / isMonthlyPay?.months|| 0;

    const monthlypaymentDivde   = monthlypayments.toFixed(2);

    const checkItemOnCart = async () => {
        const result = await useCheckCart(
            `b-${item?.id ?? item?.bundle_id}`
        );
        setItemOnCart(result);
    };

    useEffect(() => {
        getPriceData();
    }, [item]);

    useEffect(() => {
        checkItemOnCart();
    }, []);

    useEffect(() => {
        getBundlePricingForMonth();
    }, []);

    const { enqueueSnackbar } = useSnackbar();

    const addToCart = async () => {
        if (itemOnCart) {
            push("/cart");
        } else {
            const result = await useAddToCart(
                `b-${item?.id ?? item?.bundle_id}`
            );
            enqueueSnackbar(getString("Added to cart"), {
                variant: "success",
            });
            setItemOnCart(true);
            dispatch({
                type: reduxHelper.UPDATE_CART_ITEMS,
                payload: [...cartItems, `b-${item?.id ?? item?.bundle_id}`],
            });
        }
    };


    const enrollFreeBundle = async () => {
        if (user) {
            jsonData.items[0]['subscribers'][0]['us_name'] = user?.us_name;
            jsonData.items[0]['subscribers'][0]['us_email'] = user?.us_email;
            jsonData.items[0]['subscribers'][0]['us_phone'] = user?.us_phone;
            jsonData.items[0]['subscribers'][0]['id'] = user?.id

            // jsonData['user_details']['billing_details']['billing_name'] = user?.us_name;
            // jsonData['user_details']['billing_details']['billing_email'] = user?.us_email;
            // jsonData['user_details']['billing_details']['billing_phone'] = user?.us_phone;,


            jsonData['payment_success_callback'] = `/bundle/${item.bb_slug}`
            post(HTTP_REST_URLS.PAYMENT_URL, { data: jsonData })
        }
        else {
            dispatch({
                type: reduxHelper.UPDATE_ALERT,
                payload: true
            })
        }

    }

    const checkLoginEnroll = () => {
        const result = Cookies.get(CALL_BACK_URL_KEY)
        if (result) {
            const parsedResult = JSON.parse(result)
            if (parsedResult?.type === 'checkout' && isFree && !hasAddons) {
                if (user?.us_role_id == 2) {
                    setEnrolling(true)
                    enrollFreeBundle()
                }
            }
        }
    }

    useEffect(() => {
        checkLoginEnroll()
    }, [isFree, user])


    const [jsonData, setJsonData] = useState({

        "items": [
            {
                "id": item.id,
                "type": 2,
                "name": item.bb_title,
                "thumbnail": item.bb_image,
                "unitPrice": 0,
                "created_by": 1,
                "subscribers": [
                    {
                        "status": 1,
                        "us_name": user?.us_name,
                        "us_email": user?.us_email,
                        "id": user?.id,
                        "us_phone": user?.us_phone,
                        "item_price": 0,
                        "discount": 0,
                        "base_price": 0,
                        "tax": 0,
                        "total_price": 0,
                        "tax_mode": 2,
                        "tax_data": {
                            "SGST": 0,
                            "CGST": 0
                        },
                        "type": "2",
                        "addon": [],
                        "meta_data": {
                            "user_profile_fields": []
                        },
                        "created_by": 1
                    }
                ],
                "couponApplied": false,
                "couponDiscountVal": ""
            }
        ],
        "gross_amount": 0,
        "sub_total_price": 0,
        "total_tax": 0,
        "coupon_applied": false,
        "coupon_id": "",
        "coupon_discount": 0,
        "total_price": 0,
        "sold_by": "",
        "user_details": {
            "id": user?.id,
            "us_name": user?.us_name,
            "us_email": user?.us_email,
            "us_phone": user?.us_phone,
            "billing_details": {
                "billing_name": user?.us_name,
                "billing_email": user?.us_email,
                "billing_phone": user?.us_phone,
                "billing_street": "",
                "billing_state": "",
                "billing_city": "",
                "billing_district": ""
            }
        },
        "payment_success_callback": "",
        "payment_error_callback": "/cart",
        "payment_mode": 1,
        "theme": "red",
        "referral_by": "",
        "payment_due_date": "",
        "addonPrice": 0,
        "deliveryCharges": 0,
        "couponCode": null,
        "couponForallCourses": true,
        "couponDiscount": 0,
        "couponDiscountVal": ""
    })

    function post(path, params, method = 'post') {

        const form = document.createElement('form');
        form.method = method;
        form.action = path;

        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = key;
                hiddenField.value = JSON.stringify(params[key]);

                form.appendChild(hiddenField);
            }
        }

        document.body.appendChild(form);
        form.submit();
        Cookies.remove(CALL_BACK_URL_KEY);

    }





    const isPaid        = priceData?.originalPrice > 0

    const { isFree }    = priceData || {};
    const isMonthly     = priceData?.isMonthlyPayment;

    const showAction    =(isFree || isPaid || isMonthly || hasAddons) && (showPricing || enableBundlePurchase) &&((!enrolled && (selfEnrolled == '0'|| selfEnrolled == "" || selfEnrolled == null || (selfEnrolled == '1' && !isFutureDate))) ||(enrolled && bundleSubscriptionExpired));



    const actionConfig = useMemo(() => {
        if (!showAction) return null

        if ((isPaid || isMonthly || (isFree && hasAddons)) && showPricing) {
            return itemOnCart
                ? { label: getString("Go to cart"), icon: <ShoppingCartCheckoutRounded />, onClick: () => push("/cart") }
                : { label: getString("Add to cart"), icon: <ShoppingCartRounded />, onClick: addToCart }
        }

        if (isFree && !hasAddons && enableBundlePurchase) {
            return {
                label: getString("Enroll now"),
                onClick: e => {
                    // e.stopPropagation()
                    enrollFreeBundle();
                },
            }
        }

        return null
    }, [showAction, isPaid, isFree, itemOnCart, navigatePath, push, addToCart, hasAddons])


    const { push } = useRouter();
    const theme = useTheme();
    const isIOS = useMediaQuery(theme.breakpoints.only("xs"));
    const cardHeight = isIOS ? "150px" : "100%";

    return (
        <>
            {priceData && view === "list" && isDesktop && (
                <Stack direction="row" spacing={2}
                    sx={{ borderBottom: 1, width: "100%", borderColor: "divider", py: 2, cursor: "pointer", pl: "10px" }}
                    onClick={() => push(navigatePath)}
                >
                    <Box sx={{ width: "230px", height: "130px", position: "relative", ml: "20px" }}>
                        <StackImage src={thumbnail} onClick={() => push(navigatePath)} />
                    </Box>

                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box sx={{ maxWidth: "600px" }}>
                                <Box sx={{ height: "28px", marginBottom: "10px" }}>
                                    <Typography sx={{ display: "-webkit-box", WebkitLineClamp: 1, WebkitBoxOrient: "vertical", overflow: "hidden", textOverflow: "ellipsis", fontSize: "16px", fontWeight: 500, }}>
                                        {code ? `${code} - ${title}` : title}
                                    </Typography>
                                </Box>
                                <Box >
                                    <Typography color="text.secondary" sx={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden", textOverflow: "ellipsis", fontSize: "14px" }}>
                                        <div dangerouslySetInnerHTML={{ __html: shortDescription}} />
                                    </Typography>
                                </Box>
                            </Box>
                            {isFree && enableBundlePurchase ? (
                                <Box textAlign="right" sx={{ py: "10px" }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>Free</Typography>
                                </Box>
                            ) : showPricing && !isFree ? (
                                item?.bb_paytype === "1" ? (
                                    <Box textAlign="right" sx={{ py: "10px" }}>
                                        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>{priceSymbol}{priceData?.originalPrice}</Typography>
                                        {priceData?.hasStrike && (
                                            <Typography  variant="body2"  color="text.secondary" sx={{ textDecoration: "line-through", fontSize: "12px" }}>
                                                {priceSymbol}{priceData?.strikeOutPrice}
                                            </Typography>
                                        )}
                                    </Box>
                                ) : !isMonthlyPay?.months ? (
                                    <Box textAlign="right" sx={{ py: "10px" }}>
                                        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}> -</Typography>
                                    </Box>
                                ) : (
                                    <Box textAlign="right" sx={{ py: "10px" }}>
                                        <Stack alignItems="flex-end">
                                            <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                                                {priceSymbol} {isMonthlyPay?.price}
                                            </Typography>

                                            <Typography variant="caption" color="text.secondary">
                                                {priceSymbol} {monthlypaymentDivde} / {getString("month")}
                                            </Typography>
                                        </Stack>
                                    </Box>
                                )
                            ) : <></>
                        }
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", py: "10px" }}>
                            {/* <Box sx={{ display: "flex", gap: 1 }}>
                                {totalRating > 0 && (<Typography sx={{ color: "#c4710d", fontSize: "14px" }}>{totalRating} </Typography>)}
                                <Rating value={totalRating} readOnly precision={0.5} sx={{ color: " #c4710d", "& .MuiSvgIcon-root": { fontSize: "16px", } }} />
                            </Box> */}
                            <Box>
                                {actionConfig && (
                                    <Button variant="contained" size="small" startIcon={actionConfig.icon} onClick={e => { e.stopPropagation(); actionConfig.onClick(); }}
                                        sx={{ whiteSpace: "nowrap", minWidth: 110, height: 35, borderRadius: "5px" , textTransform:"none"}}
                                    >
                                        {actionConfig.label}
                                    </Button>
                                )}
                                { ( selfEnrolled == '1' &&   isFutureDate &&  ((isFree && enableBundlePurchase) || ((isPaid || isMonthly) && showPricing) || (showPricing && enableBundlePurchase))&& (<Typography color={ 'red'} variant={'caption'} fontWeight={500}>  Available from <span style={{ marginLeft: 4 }}>{selfEnrolledDate} </span> </Typography>))}
                            </Box>
                        </Box>
                    </Box>

                </Stack>
            )}

            {view === "grid" && isDesktop && (
                <Stack sx={{ boxSizing: "border-box", cursor: "pointer", mt: "10px", px: "10px" }} onClick={() => push(navigatePath)}>
                    <Box sx={{ position: "relative", height: "200px", width: "100%" }}>
                        <StackImage src={thumbnail} view={view} onClick={() => push(navigatePath)} />
                    </Box>
                    <Box>
                        <Box sx={{ height: "45px", marginY: "10px" }}>
                            <Typography variant="subtitle1"
                                sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", fontSize: "16px", fontWeight: 500, }}
                            >
                              {code ? `${code} - ${title}` : title}
                            </Typography>

                        </Box>
                        <Box sx={{ height: "35px" }}>
                            <Typography variant="body2" color="text.secondary"
                                sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", fontSize: "14px", textOverflow: "ellipsis" }}
                            >
                                <div dangerouslySetInnerHTML={{ __html: shortDescription}} />
                            </Typography>
                        </Box>
                        {/* <Box sx={{ display: 'flex', gap: 1, py: "12px" }}>
                            {totalRating > 0 && (
                                <Typography sx={{ color: "#c4710d", fontSize: "14px" }}>
                                    {totalRating}
                                </Typography>
                            )}
                            <Rating value={totalRating} readOnly precision={0.5} sx={{ color: " #c4710d", "& .MuiSvgIcon-root": { fontSize: "16px", } }} />

                        </Box> */}
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: "12px"}}>
                            {
                                isFree && enableBundlePurchase ? (
                                    <Box sx={{ display: "flex", gap: 1 }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                                        Free
                                    </Typography>
                                    </Box>
                                ) : showPricing && !isFree ? (
                                    item?.bb_paytype === "1" ? (
                                        <Box sx={{ display: "flex", gap: 1 }}>
                                            <Typography sx={{ fontWeight: 600, fontSize: "14px" }}> {priceSymbol}{priceData?.originalPrice}</Typography>
                                            {priceData?.hasStrike && (
                                                <Typography  variant="body2" color="text.secondary"  sx={{ textDecoration: "line-through", fontSize: "12px" }}>
                                                    {priceSymbol}{priceData?.strikeOutPrice}
                                                </Typography>
                                            )}
                                        </Box>
                                    ) : !isMonthlyPay?.months ? (
                                        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}> - </Typography>
                                    ) : (
                                    <Stack direction="row" alignItems="center" gap={1}>
                                        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}> {priceSymbol} {isMonthlyPay?.price}</Typography>
                                        <Typography variant="caption" color="text.secondary">{priceSymbol} {monthlypaymentDivde} / {getString("month")}</Typography>
                                    </Stack>
                                    )
                                ) : <></>
                            }

                            {actionConfig && (
                                <Button size="small" variant="contained" startIcon={actionConfig.icon} onClick={e => { e.stopPropagation(); actionConfig.onClick(); }}
                                    sx={{ whiteSpace: "nowrap", minWidth: 100, height: 35, borderRadius: "5px", textTransform:"none" }}
                                >
                                    {actionConfig.label}
                                </Button>
                            )}
                            {( selfEnrolled == '1' &&  isFutureDate  && ((enableBundlePurchase && showPricing) || (showPricing && !isFree) || (isFree && enableBundlePurchase)) &&  ( <Typography color={ 'red'} variant={'caption'} fontWeight={500}>  Available from <span style={{ marginLeft: 4 }}>{selfEnrolledDate} </span> </Typography>))}

                        </Box>

                        {/* {enrolled && !bundleSubscriptionExpired && (
                        <LinearProgress value={percentage || 0} variant="determinate" sx={{ height: 2 }} />
                    )} */}
                    </Box>
                </Stack>
            )}

            {priceData && view === "grid" && isTablet && (
                <Stack sx={{ border: 1, borderColor: "divider", borderRadius: 2, p: '10px', boxShadow: 1, cursor: "pointer", height: 370 }}
                    onClick={() => !bundleExpired && push(navigatePath)}
                >
                    <Box sx={{ position: "relative", height: "170px", width: "100%", pt: "10px", pl: "10px", flexShrink: 0 }}>
                        <StackImage src={thumbnail} view={view} onClick={() => push(navigatePath)} />
                    </Box>
                    <Typography
                        variant="subtitle1"
                        sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", height: "70px", fontSize: "16px", fontWeight: 500, textOverflow: "ellipsis", py: "15px" }}
                    >
                      {code ? `${code} - ${title}` : title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary"
                        sx={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden", textOverflow: "ellipsis", height: "55px",  fontSize: "14px", py: "5px" }}
                    >
                        <div dangerouslySetInnerHTML={{ __html: shortDescription}} />
                    </Typography>
                    {/* <Box sx={{ display: 'flex', gap: 1, py: "10px" }}>
                        {totalRating > 0 && (
                            <Typography sx={{ color: "#c4710d", fontSize: "14px" }}>
                                {totalRating}
                            </Typography>
                        )}
                        <Rating value={totalRating} readOnly precision={0.5} sx={{ color: " #c4710d", "& .MuiSvgIcon-root": { fontSize: "16px", } }} />

                    </Box> */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" ,py: "10px"}}>
                            {
                            isFree && enableBundlePurchase? (
                                <Box sx={{ display: "flex", gap: 1 }}>
                                <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                                    Free
                                </Typography>
                                </Box>
                            ) : showPricing && !isFree ? (
                                item?.bb_paytype === "1" ? (
                                <Box sx={{ display: "flex", gap: 1 }}>
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                                        {priceSymbol}{priceData?.originalPrice}
                                    </Typography>

                                    {priceData?.hasStrike && (
                                        <Typography variant="body2" color="text.secondary" sx={{ textDecoration: "line-through", fontSize: "13px" }}>
                                            {priceSymbol}{priceData?.strikeOutPrice}
                                        </Typography>
                                    )}
                                </Box>
                                ) : !isMonthlyPay?.months ? (
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>-</Typography>
                                ) : (
                                <Stack>
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>{priceSymbol} {isMonthlyPay?.price}</Typography>
                                    <Typography variant="caption" color="text.secondary">{priceSymbol} {monthlypaymentDivde} / {getString("month")}</Typography>
                                </Stack>
                                )
                            ) : <></>
                        }
                        {actionConfig && (
                            <Button variant="contained" size="small" startIcon={actionConfig.icon} onClick={e => { e.stopPropagation(); actionConfig.onClick(); }}
                                sx={{ whiteSpace: "nowrap", minWidth: 110, height: 35, borderRadius: "5px", textTransform:"none"}}
                            >
                                {actionConfig.label}
                            </Button>
                        )}
                        { ( selfEnrolled == '1' &&  isFutureDate && ((isFree && enableBundlePurchase) || ((isPaid || isMonthly) && showPricing) || (showPricing && enableBundlePurchase))&&  (<Typography color={ 'red'} variant={'caption'} fontWeight={500}>  Available from <span style={{ marginLeft: 4 }}>{selfEnrolledDate} </span> </Typography>))}

                    </Box>
                    {/* {enrolled && !bundleSubscriptionExpired && (
                        <LinearProgress value={percentage || 0} variant="determinate" sx={{ height: 2 }} />
                    )} */}
                </Stack>
            )}

            {priceData && view === "grid" && isMobile && (
                <Stack
                    direction="row" spacing={2}
                    sx={{ width: "100%", border: 1, borderColor: "divider", borderRadius: 2, p: 2, boxShadow: 1, cursor: "pointer", }}
                    onClick={() => !bundleExpired && push(navigatePath)}
                >
                    <Box sx={{ width: "72px", height: "65px", flexShrink: 0, }}>
                        <StackImage src={thumbnail} view={view} onClick={() => push(navigatePath)} />
                    </Box>
                    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                        <Typography sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", height: "3.2em", fontSize: "14px", fontWeight: 500, textOverflow: 'ellipsis' }}>
                            {code ? `${code} - ${title}` : title}
                        </Typography>
                        <Typography
                            color="text.secondary"
                            sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", fontSize: "13px", textOverflow: "ellipsis", }}
                        >
                            <div dangerouslySetInnerHTML={{ __html: shortDescription}} />
                        </Typography>
                        {/* <Box sx={{ display: 'flex', gap: 1, my: 1 }}>
                            {totalRating > 0 && (
                                <Typography sx={{ color: "#c4710d", fontSize: "14px" }}>
                                    {totalRating}
                                </Typography>
                            )}
                            <Rating value={totalRating} readOnly precision={0.5} sx={{ color: " #c4710d", "& .MuiSvgIcon-root": { fontSize: "15px", } }} />

                        </Box> */}
                        { ( selfEnrolled == '1' &&  isFutureDate && ((isFree && enableBundlePurchase) || ((isPaid || isMonthly) && showPricing) || (showPricing && enableBundlePurchase)) &&  (<Typography color={ 'red'} variant={'caption'} fontWeight={500}>  Available from <span style={{ marginLeft: 4 }}>{selfEnrolledDate} </span>s</Typography>))}

                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 1 }} >
                            {
                                isFree && enableBundlePurchase && !showPricing ? (
                                    <Box sx={{ display: "flex", gap: 1 }}>
                                        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}> Free</Typography>
                                    </Box>
                                ) : enableBundlePurchase && !isFree ? (
                                    item?.bb_paytype === "1" ? (
                                    <Box sx={{ display: "flex", gap: 1 }}>
                                        <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                                        {priceSymbol}{priceData?.originalPrice}
                                        </Typography>

                                        {priceData?.hasStrike && (
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ textDecoration: "line-through", fontSize: "12px" }}
                                        >
                                            {priceSymbol}{priceData?.strikeOutPrice}
                                        </Typography>
                                        )}
                                    </Box>
                                    ) : !isMonthlyPay?.months ? (
                                    <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                                        -
                                    </Typography>
                                    ) : (
                                    <Stack>
                                        <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                                        {priceSymbol} {isMonthlyPay?.price}
                                        </Typography>

                                        <Typography variant="caption" color="text.secondary">
                                        {priceSymbol} {monthlypaymentDivde} / {getString("month")}
                                        </Typography>
                                    </Stack>
                                    )
                                ) : <></>
                            }

                            
                            {actionConfig && (
                                <Button variant="contained" startIcon={actionConfig.icon} onClick={e => { e.stopPropagation(); actionConfig.onClick(); }}
                                    sx={{ whiteSpace: "nowrap", width: 100, height: 30, borderRadius: "5px", fontSize: "12px", textTransform:"none" }}
                                >
                                    {actionConfig.label}
                                </Button>
                            )}
                        </Stack>
                    </Box>
                </Stack>
            )}
        </>
    );

}

export default BundlesCard;
